import React from "react";
import { SlideData } from "../../interfaces/SliderData";

const getYouTubeId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
};

export function Slide({ data, pr }: { data: SlideData, pr: boolean }) {
    const ytId = data.video ? getYouTubeId(data.video) : null;

    return (
        // El contenedor ahora es blanco puro. Si la pantalla es muy ancha, los lados se camuflan.
        <div className={`relative w-full bg-white overflow-hidden md:overflow-visible flex flex-col items-center justify-center ${data.video ? "min-h-[300px] md:min-h-[480px]" : ""}`}>

            {/* FONDO: Video o Imagen Real */}
            {data.video && ytId ? (
                <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 bg-black">
                    <iframe
                        className="absolute top-1/2 left-1/2 w-[150vw] h-[150vh] min-w-full min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
                        src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=1&loop=1&controls=0&playlist=${ytId}&showinfo=0&rel=0`}
                        title="YouTube background video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                </div>
            ) : (
                // Usamos la etiqueta img con max-h-full para que NUNCA se corte ni un pixel de los botes ni reflejos
                <div className="w-full h-auto md:max-h-none z-0 flex items-center justify-center overflow-visible">
                    {/* Desktop/Default Image */}
                    <img
                        src={data.imagen}
                        alt="Imagen L'Oréal"
                        className={`w-full h-auto object-contain ${
                            (data.imagenMobile || data.imageMobile) ? "hidden md:block" : "block"
                        }`}
                    />
                    {/* Mobile Image */}
                    {(data.imagenMobile || data.imageMobile) && (
                        <img
                            src={data.imagenMobile || data.imageMobile}
                            alt="Imagen L'Oréal Móvil"
                            className="w-full h-auto max-h object-contain md:hidden"
                        />
                    )}
                </div>
            )}

            {/* OVERLAY SUTIL */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/[0.01] via-transparent to-transparent z-10 pointer-events-none"></div>

            {/* CONTENIDO: Fijado abajo a la izquierda de forma limpia */}
            <div className="relative w-full pt-2 px-6 pb-6 md:pb-12 md:px-32 lg:px-44 mt-[-200px] md:mt-[-70px] z-20 flex flex-col justify-end pointer-events-auto">
                {/* Texto oscuro */}
                <div className="w-full md:w-7/12 pointer-events-auto text-gray-900">
                    {data.tittle && (
                        <div className={`text-xl md:text-2xl lg:text-4xl font-Playfair font-bold leading-tight ${data.tittleMobile ? "hidden md:block" : ""}`}>
                            {data.tittle}
                        </div>
                    )}
                    {data.subTittle && (
                        <div className={`text-base md:text-lg lg:text-xl font-Playfair opacity-80 mt-1 ${data.tittleMobile ? "hidden md:block" : ""}`}>
                            {data.subTittle}
                        </div>
                    )}

                    {data.tittleMobile && (
                        <div className="block md:hidden text-xl text-left font-semibold font-Playfair">
                            {data.tittleMobile}
                        </div>
                    )}

                    {pr && data.url && (
                        <a
                            href={data.url}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-block bg-black text-white font-medium px-5 py-2 mt-3 rounded hover:bg-gray-800 transition text-sm"
                        >
                            Aquí
                        </a>
                    )}

                    {data.description && (
                        <div className="text-sm md:text-sm lg:text-base mt-2 opacity-90">
                            {data.description}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}